
import {  Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { GenerateLicenseForm } from "../../form/GenerateLicenseForm";
import { useGenericDrawer } from "../../../../hooks/drawer/useGenericDrawer";



type GenerateLicenseDrawerProps = {
  onGenerateLicenseCallBackFn: (obj:any) => any;
  isDrawerOpen: boolean;
  setDrawerOpen: (isDrawerOpen: boolean) => void;

};

export const GenerateLicenseDrawer: React.FC<GenerateLicenseDrawerProps> = ({
  isDrawerOpen,
  setDrawerOpen,
  onGenerateLicenseCallBackFn
  // licenseSerialNumberToGenerateLicense,
  //licenseProductCode
}) => {
  const { t } = useTranslation();

  const referenceDrawer = useGenericDrawer()

  return (

    <Drawer
      title={t("licenses.basic.detail.generate.title")}
      placement="right"
      width={750}
      closable={true}
      onClose={() => setDrawerOpen(false)}
      open={isDrawerOpen}
      bodyStyle={{ padding: '32px' }}
    >
     {isDrawerOpen && <GenerateLicenseForm onGenerateLicenseCallBackFn={onGenerateLicenseCallBackFn} referenceDrawer={referenceDrawer} onCloseDrawer={setDrawerOpen} />}
    </Drawer>
  );
};
